import { Text } from '@common-fe/common-fe';
import styled from 'styled-components';

const AccentText = styled(Text)<{ fontSize?: number }>`
  font-family: 'Oswald', serif;

  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : undefined)};
`;

export default AccentText;
